import React from "react";

interface ErrorAlertProps {
  message: string;
  onClose?: () => void;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ message, onClose }) => (
  <div className="alert alert-danger d-flex align-items-center justify-content-between" role="alert" style={{ maxWidth: 600, margin: "20px auto" }}>
    <div className="d-flex align-items-center gap-2">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-exclamation-triangle-fill text-danger" viewBox="0 0 16 16">
        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.964 0L.165 13.233c-.457.778.091 1.767.982 1.767h13.707c.89 0 1.438-.99.982-1.767L8.982 1.566zm-.982.874c.246-.41.84-.41 1.086 0l6.853 11.667c.246.418-.062.893-.543.893H1.604c-.48 0-.789-.475-.543-.893L8 2.44zm.93 9.443a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-.002-2.002a.5.5 0 0 1-.998 0l-.35-3.5a.5.5 0 0 1 .998 0l.35 3.5z"/>
      </svg>
      <span>{message}</span>
    </div>
    {onClose && (
      <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
    )}
  </div>
);

export default ErrorAlert;
